// extracted by mini-css-extract-plugin
export var button = "_kw-0";
export var donut = "_kw-1";
export var donutFill = "_kw-3";
export var donutTrack = "_kw-2";